// extracted by mini-css-extract-plugin
module.exports = {"title":"sign-up_title__AFvZM","title-box":"sign-up_title-box__24d7g"};